<template>
    <main class="swiper">
        <el-carousel trigger="click" :height="bannerHeight + 'px'" :interval="6000">
            <el-carousel-item v-for="(item, index) of imageDatas" :key="index">
                <img v-if="item.imageId" ref="bannerHeight" style="cursor: pointer; width: 100%;" :src="`https://order.cateraway.com/api/file/image/${item.imageId}`" alt="" @load="swiperLoad()"/>
            </el-carousel-item>
        </el-carousel>
    </main>
</template>
<script>
export default {
    props:{
        images:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    watch:{
        images(newValue){
            this.imageDatas = newValue
        }
    },
    data(){
        return {
            bannerHeight: 300,
            windowWidth: document.documentElement.clientWidth,
            imageDatas:[]
        }
    },
    mounted(){
        this.imageDatas = this.images
        if (this.images.length > 0){
            window.addEventListener("resize", () => {
                if (this.$refs.bannerHeight && this.$refs.bannerHeight.length > 0) {
                    this.swiperLoad();
                }
            });
            // 監聽窗口大小
            this.swiperLoad();
        }
    },
    methods:{
        // 页面加载后获取窗口大小
        swiperLoad() {
            this.$nextTick(() => {
                if (this.$refs.bannerHeight.length > 0) {
                    this.bannerHeight = this.$refs.bannerHeight && this.$refs.bannerHeight[0].height;
                }
            });
        },
        showImage(link) {
            if (link && link !== '') {
                window.open(link, "_blank");
            } else {
                if (this.$i18n.locale === "zh") {
                    this.$router.push("/menu/");
                } else {
                    this.$router.push("/en/menu/");
                }
            }
        },
    },
    unmounted() {
        window.removeEventListener("resize")
    },
}
</script>
<style lang="less" scoped>
    .swiper{
        width: 100%;
    }
</style>
